import actions from './ppt-addin.actions'
import getters from './ppt-addin.getters'

export default {
  namespaced: true,
  actions,
  getters,
}
